import React from "react";

import Select from "react-select";
import { isEmpty } from "lodash";
import { Trans, useTranslation } from "react-i18next";

import StepsNavButtons from "../Buttons/StepsNavButtons";
import TitleWithDescription from "../Headers/TitleWithDescription";
import {
    getReactSelectTheme,
    getReactSelectStyling,
} from "../../utils/ReactSelectStyles";
import SimpleNotification from "../Notifications/SimpleNotification";

const SelectProducts = ({
    selectedProducts,
    setSelectedProducts,
    setMaterialNames,
    acceptedProducts,
    nextStep,
    nextStepButtonText,
}) => {
    const { t } = useTranslation();

    const handleMultiSelect = (newValue, action) => {
        let newPropertyVals = [...selectedProducts];
        switch (action.action) {
            case "select-option":
                newPropertyVals.push(action.option);
                break;
            case "remove-value":
                newPropertyVals = newPropertyVals.filter(
                    (unit) => unit.value !== action.removedValue.value
                );
                break;
            case "clear":
                newPropertyVals = [];
        }

        setSelectedProducts(newPropertyVals);
        setMaterialNames(newPropertyVals.map((p) => p.materialName));
    };

    const renderFields = () => {
        return (
            fields &&
            fields.map((field, index) => {
                if (!field.hide) {
                    const inputGroup = field.element();
                    return (
                        <div className="tags input-group" key={index}>
                            <h4 className="uppercase text-xs required">
                                {inputGroup.label}
                            </h4>

                            {inputGroup.input}
                        </div>
                    );
                }
            })
        );
    };

    const fields = [
        {
            element: () => {
                return {
                    label: (
                        <Trans i18nKey="publishBundleStep1">
                            Select Products
                        </Trans>
                    ),
                    input: (
                        <Select
                            options={acceptedProducts}
                            isMulti
                            value={
                                isEmpty(selectedProducts)
                                    ? ""
                                    : selectedProducts
                            }
                            onChange={handleMultiSelect}
                            placeholder={t("selectPlaceholder", {
                                entity: "Products",
                            })}
                            getOptionValue={(option) =>
                                option.searchable || option.label
                            }
                            theme={getReactSelectTheme}
                            styles={getReactSelectStyling({
                                isMultiSelect: true,
                            })}
                        />
                    ),
                };
            },
        },
    ];

    return (
        <>
            <div className="steps step1 show">
                <TitleWithDescription
                    title={t("publishModelStep1")}
                    description={t("publishBundleStep1Paragraph")}
                />
                <div className="card-table shadow flex flex-col">
                    {renderFields()}
                    <SimpleNotification
                        message={t(
                            "multiSelectProductWithSameMaterialWarningMessage"
                        )}
                    />
                </div>
            </div>
            <StepsNavButtons
                next={{
                    action: nextStep,
                    disabled: isEmpty(selectedProducts),
                    label: nextStepButtonText,
                }}
            />
        </>
    );
};

export default SelectProducts;
